import { create } from 'zustand';

const useCompaniesFacturationStore = create((set) => {
    return {
        companiesFacturation: [],
        setCompaniesFacturation: (companiesFacturation) => {
            const timestamp = new Date().getTime();
            const updatedCompaniesFacturation = Array.isArray(companiesFacturation)
                ? companiesFacturation.map((companyFacturation) => ({
                    ...companyFacturation,
                    timestamp
                }))
                : [];
            set({ companiesFacturation: updatedCompaniesFacturation });
        },
        addCompanyFacturation: (companyFacturation) => {
            const timestamp = new Date().getTime();
            const updatedCompanyFacturation = { ...companyFacturation, timestamp };
            set((state) => ({
                companiesFacturation: [...state.companiesFacturation, updatedCompanyFacturation]
            }));
        },
        clearCompaniesFacturation: () => {
            set({ companiesFacturation: [] });
        },
    };
});

export default useCompaniesFacturationStore;